import { DeleteOutlined, SaveOutlined, SyncOutlined } from '@ant-design/icons';
import { Button, Row } from 'antd';
import React from 'react';
import { popupConfirmDeleteWithCallback } from '../../helpers/NotificationHelper';
import { Props } from './index';

class DrawerButtons extends React.PureComponent<Props> {
    public constructor(props: Props) {
        super(props);
    }

    public render(): React.ReactElement {
        const {
            isSaving,
            isFormDirty,
            onCancelAction,
            onSubmitAction,
            onDeleteAction,
            deleteConfirmMessage,
        } = this.props;

        return (
            <Row style={{ height: 50, display: 'flow-root', paddingRight: 40 }}>
                <div style={{ float: 'right' }}>
                    <Button type="default" style={{ width: 100 }} onClick={onCancelAction}>
                        Cancel
                    </Button>
                    <Button
                        type="primary"
                        style={{
                            marginLeft: 10,
                            width: 100,
                        }}
                        htmlType="submit"
                        disabled={!!isSaving || (isFormDirty !== undefined && !isFormDirty)}
                        onClick={onSubmitAction}
                    >
                        {isSaving ? (
                            <SyncOutlined spin className="button-icon-display" />
                        ) : (
                            <SaveOutlined className="button-icon-display" />
                        )}
                        {isSaving ? 'Saving' : 'Save'}
                    </Button>
                    {onDeleteAction && (
                        <Button
                            type="primary"
                            danger
                            style={{
                                marginLeft: 10,
                                width: 100,
                            }}
                            disabled={isSaving}
                            onClick={(): void =>
                                popupConfirmDeleteWithCallback(
                                    (): Promise<void> => onDeleteAction(),
                                    undefined,
                                    deleteConfirmMessage || undefined
                                )
                            }
                        >
                            <DeleteOutlined className="button-icon-display" />
                            Delete
                        </Button>
                    )}
                </div>
            </Row>
        );
    }
}

export default DrawerButtons;
